import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const Repayments = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="repayments"
            prevLink={ROUTE_NAME.FAQ_TYPES_OF_INVESTMENT_NOTES}
            prevTitle={dict.typesOfInvestmentNotes}
            nextLink={ROUTE_NAME.FAQ_INVESTMENT_MEMOS}
            nextTitle={dict.investmentMemos}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.financingPlatform}
                        </h3>
                    </div>
                    <div className="card__title">
                        <h4 className="bold-text" style={{ color: '#264391' }}>
                            {dict.repayments}
                        </h4>
                    </div>
                    <p>
                        <strong>
                            {dict.repaymentsTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.repaymentsTitle1Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.repaymentsTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.repaymentsTitle2Text1}
                    </p>
                    <p>
                        {dict.repaymentsTitle2Text2}
                    </p>
                    <p>
                        <strong>
                            {dict.repaymentsTitle3}
                        </strong>
                    </p>
                    <p>
                        {dict.repaymentsTitle3Text1}
                    </p>
                    <p>
                        {dict.repaymentsTitle3Text2}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default Repayments;
